// Layouts
export PageWrapperLayout from './core-layout'; // Page wrapper
export ComponentsLayout from './components-layout';
export HomePageLayout from './home-page-layout';



// WEBPACK FOOTER //
// ./public/src/layouts/index.js